import React from 'react';
import BaseInvoiceProfile from '@fingo/lib/components/invoice-profile/BaseInvoiceProfile';
import Box from '@mui/material/Box';
import useInvoiceProfile from '@fingo/lib/hooks/useInvoiceProfile';

const InvoiceProfile = () => {
  const { summaryHeaders, needsCreditNote } = useInvoiceProfile();

  return (
    <Box paddingTop={3} paddingRight={3}>
      <BaseInvoiceProfile
        summaryHeaders={summaryHeaders}
        needsCreditNote={needsCreditNote}
      />
    </Box>
  );
};

export default InvoiceProfile;
